<template>
  <v-card
    :color="color"
    class="d-flex"
    hover
    max-width="250"
    ripple
    @click="addProductToCart()"
  >
    <v-card-title class="align-start font-weight-bold text-center flex-grow-1">
      <div class="v-card-name text-subtitle-2">
        <template v-if="$store.getters.locale === $store.state.secondaryLocale">{{ product.nameTranslated }}</template>
        <template v-else>{{ product.name }}</template>
      </div>
    </v-card-title>
    <v-card-actions class="align-end">
      <v-spacer />
      <v-progress-circular
        v-show="$wait.is(`${product.id} adding to cart`)"
        :size="25"
        :width="3"
        indeterminate
      />
      <v-chip
        v-show="!$wait.is(`${product.id} adding to cart`)"
        dark
        label
        small
      >
        {{ product.retailPrice | money }}
      </v-chip>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ProductBtn',

  props: {
    color: {
      type: String,
      default: ''
    },
    product: {
      type: Object,
      default: null
    }
  },

  methods: {
    addProductToCart () {
      this.$wait.start(`${this.product.id} adding to cart`)
      return this.$store.dispatch('RECEIPT/ADD_PRODUCT', { id: this.product.id, qty: 1 })
        .then(data => {
          this.helpers.toastSuccess(data.message)
          this.$emit('added-to-cart')
        })
        .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
        .finally(() => this.$wait.end(`${this.product.id} adding to cart`))
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  flex-direction: column;
  height: 100%;
}

.v-card:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/checkout/ProductButton.vue